/* app/js/src/components/scheduler/libraryUploader/libraryUploader.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer {
  cursor: pointer;
}
.upload-item-base,
.upload-uploading-state {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  max-width: calc(49% - 5px);
  min-width: calc(49% - 5px);
  width: calc(49% - 5px);
  position: relative;
}
.upload-item-base > span,
.upload-uploading-state > span {
  display: block;
  position: absolute;
  bottom: 7.5%;
  white-space: nowrap;
  left: 17.5%;
  width: 65%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.7em;
  letter-spacing: 0.1px;
  color: #879baf;
  text-transform: uppercase;
  text-align: center;
}
.upload-item-base button,
.upload-uploading-state button {
  background-color: #eef2f6;
  height: 22px;
  width: 22px;
  border-radius: 50%;
  position: absolute;
  top: 5%;
  right: 5%;
  border: none;
  padding: 0;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.upload-item-base button svg,
.upload-uploading-state button svg {
  width: 12px;
  height: 12px;
  fill: #879baf;
}
.upload-item-base button:focus,
.upload-uploading-state button:focus {
  outline: none;
}
.upload-item-base button:hover,
.upload-uploading-state button:hover {
  background-color: #879baf;
}
.upload-item-base button:hover svg,
.upload-uploading-state button:hover svg {
  fill: #fdfefe;
}
.upload-uploading-state {
  background-color: #ffffff;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  max-width: 100%;
}
.upload-uploading-state svg circle {
  stroke-width: 3px;
  stroke: #c6d2df;
  fill: #ffffff;
}
.upload-uploading-state svg circle:last-child {
  stroke-dasharray: 115;
  stroke-dashoffset: 115;
  stroke: #40c4ff;
  fill: rgba(255, 255, 255, 0);
  transform-origin: center center;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.upload-uploading-state i.uploading {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.upload-uploading-state i.uploading > span {
  font-size: 0.8em;
  text-decoration: none;
  font-style: normal;
  color: #40c4ff;
  position: absolute;
}
.upload-uploading-state i.uploading > span::after {
  content: "%";
}
.upload-uploading-state i.upload-success svg circle {
  stroke-width: 3px;
  stroke: #c6d2df;
  fill: #ffffff;
}
.upload-uploading-state i.upload-success svg circle:last-child {
  stroke-dasharray: 115;
  stroke-dashoffset: 10;
  stroke: #40c4ff;
  fill: rgba(255, 255, 255, 0);
  transform-origin: center center;
  -webkit-transition: all 1.2s ease;
  transition: all 1.2s ease;
  -webkit-animation-delay: 0s;
  -webkit-animation-duration: 1.2s;
  -webkit-animation-name: rotate;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-delay: 0s;
  -moz-animation-duration: 1.2s;
  -moz-animation-name: rotate;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: infinite;
  -o-animation-delay: 0s;
  -o-animation-duration: 1.2s;
  -o-animation-name: rotate;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: infinite;
  animation-delay: 0s;
  animation-duration: 1.2s;
  animation-name: rotate;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
}
.upload-uploading-state i.upload-success svg path {
  fill: #ffffff;
  -ms-transform: translate(10px, 14px);
  -webkit-transform: translate(10px, 14px);
  transform: translate(10px, 14px);
}
.upload-uploading-state i.upload-failure svg {
  width: 46px;
  height: 44px;
}
.upload-uploading-state i.upload-failure svg path {
  fill: #ef5350;
  -ms-transform: translate(0, 0);
  -webkit-transform: translate(0, 0);
  transform: translate(0, 0);
}
.upload-uploading-state span.analyzing {
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-name: analyzingEnter;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: analyzingEnter;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0;
  -o-animation-duration: 0.2s;
  -o-animation-name: analyzingEnter;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0;
  animation-duration: 0.2s;
  animation-name: analyzingEnter;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  -ms-transform: translateY(-15px);
  -webkit-transform: translateY(-15px);
  transform: translateY(-15px);
  font-weight: 700;
}
.upload-uploading-state span.offline-indicator {
  position: absolute;
  top: 9.5%;
  left: 5%;
  font-size: 0.7em;
  font-style: normal;
  font-weight: 600;
  color: #879baf;
  bottom: auto;
  text-align: left;
}
.upload-uploading-state span.offline-indicator a {
  font-size: inherit;
  color: inherit;
  text-decoration: none;
}
.upload-uploading-state span.offline-indicator a:link,
.upload-uploading-state span.offline-indicator a:active {
  text-decoration: none;
}
@keyframes analyzingEnter {
  from {
    opacity: 0;
    -ms-transform: translateY(0px);
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
  to {
    opacity: 1;
    -ms-transform: translateY(-15px);
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
/*# sourceMappingURL=libraryUploader.component.css.map */
